interface EditadoPorRodapeProps {
  dados: {
    editadoPor?: {
      username?: string;
      nome?: string | null;
      pessoa?: { nome?: string | null } | null;
    };
    editadoEm?: Date | string;
  };
}

function texto(valor: unknown) {
  return typeof valor === 'string' ? valor.trim() : '';
}

function primeiroEUltimoNome(nomeCompleto: string) {
  const partes = nomeCompleto.split(/\s+/).filter(Boolean);
  if (partes.length <= 1) return partes[0] ?? '';
  return `${partes[0]} ${partes[partes.length - 1]}`;
}

function dataDiscreta(editadoEm: Date | string) {
  const data = new Date(editadoEm);
  if (Number.isNaN(data.getTime())) return '';
  const dois = (n: number) => String(n).padStart(2, '0');
  const ano = String(data.getFullYear()).slice(-2);
  return `${dois(data.getDate())}/${dois(data.getMonth() + 1)}/${ano} ${dois(data.getHours())}:${dois(data.getMinutes())}`;
}

export function EditadoPorRodape({ dados: { editadoPor, editadoEm } }: EditadoPorRodapeProps) {
  const bruto = texto(editadoPor?.nome) || texto(editadoPor?.pessoa?.nome) || texto(editadoPor?.username);
  const nome = primeiroEUltimoNome(bruto);
  const quando = editadoEm ? dataDiscreta(editadoEm) : '';

  if (!nome && !quando) {
    return <hr />;
  }

  const titulo = nome
    ? ['Editado por', nome, quando].filter(Boolean).join(' ')
    : `Editado em ${quando}`;

  return (
    <div className="col-md-12 text-end mt-2" title={titulo}>
      {nome && <div className="fst-italic">{nome}</div>}
      {quando && (
        <div className="text-muted" style={{ fontSize: '0.75rem' }}>
          {quando}
        </div>
      )}
      <hr />
    </div>
  );
}
